import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons"; 
import { useEffect, useState } from "react";

const RegistrationButton = ({ handleRegisterClick }) => {
    const [shake, setShake] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setShake(true);
            setTimeout(() => setShake(false), 500); 
        }, 3000); 

        return () => clearInterval(interval);
    }, []);

    return (
        <button className={`registration-button ${shake ? "shake" : ""}`} onClick={handleRegisterClick}>
            <FontAwesomeIcon icon={faShoppingCart} size="lg" />
        </button>
    );
};

export default RegistrationButton;
